import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'lib-form-pegi',
  templateUrl: './form-pegi.component.html',
  styleUrls: ['./form-pegi.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormPegiComponent implements OnInit {
  @Input() control: UntypedFormControl;
  @Input() required: boolean;
  open = true;
  chosenPegis = [];
  separator = '|';

  pegiCodes = ['6', '9', '12', '14', '16', '18', 'G', 'A', 'GT', 'D', 'S', 'DA', 'AL', 'ALT', 'NR', 'T'];

  constructor() {}

  ngOnInit(): void {
    this.chosenPegis = this.control?.value?.split(this.separator) || [];
  }

  togglePegiCode(code) {
    if (this.chosenPegis.indexOf(code) > -1) {
      this.chosenPegis = this.chosenPegis.filter((c) => c !== code);
    } else {
      this.chosenPegis.push(code);
    }

    this.updateForm(this.chosenPegis.join(this.separator));
  }

  isPegiActive(code) {
    return this.chosenPegis.indexOf(code) > -1;
  }

  updateForm(pegis) {
    this.control.setValue(pegis);
  }
}
